export class EntityLockedError extends Error {
    public status: number;
    public lockedBy?: string;
    public lockedAt?: number;

    constructor(message: string, lockedBy?: string, lockedAt?: number) {
        super(message);
        this.name = 'EntityLockedError';
        this.status = 409;
        this.lockedBy = lockedBy;
        this.lockedAt = lockedAt;
        Object.setPrototypeOf(this, EntityLockedError.prototype);
    }
}
